/* REACT */
import React, { useEffect, useState } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'

/* COMPONENTS */

/* STORE */

import {
  setLimitMessagesCase,
  setUserByPassMessagesLimit,
} from '../../store/general/actions'

/* STYLES */

/* UTILS/CONSTANTS */
import { logToConsole } from '../../utils'

/* ASSETS */

const FrenchMorningComponent = ({
  setLimitMessagesCase,
  setUserByPassMessagesLimit,
}) => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    logToConsole('FrenchMorningComponent useEffect called')
    setLimitMessagesCase(true)
    const loadScript = () => {
      logToConsole('FrenchMorningComponent Load Script called')
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://assets.poool-subscribe.fr/subscribe.js'
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    }

    loadScript()
      .then(() => {
        logToConsole('Script loaded')
        const subs = window.Subscribe.init(
          'lWC0WL7LxsqaTo91fFeGr9zjq7mffKJDPDXfbTGumTPo9QTnaIuGAmjpKpGHOllw'
        )
        return subs.getUser()
      })
      .then(user => {
        logToConsole('Poool user is', user)
        setUser(user) // Save the user in the state to use it in the component

        if (!user?.authenticated) {
          // USER ISN'T AUTHENTICATED CAN'T BYPASS PAYWALL
          setUserByPassMessagesLimit(false)
        } else {
          // USER IS AUTHENTICATED CAN BYPASS PAYWALL
          setUserByPassMessagesLimit(true)
        }
      })
      .catch(error => {
        logToConsole('Error loading Poool script FrenchMorningComponent')
        console.error('Error loading Poool script for fetching user:', error)
        if (process.env.REACT_APP_API_ENV === 'production') {
          setUserByPassMessagesLimit(false)
        }
      })
  }, []) // Empty dependency array to run only once

  return <></> // Return an empty fragment so no UI is rendered
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  setLimitMessagesCase: value => dispatch(setLimitMessagesCase(value)),
  setUserByPassMessagesLimit: value =>
    dispatch(setUserByPassMessagesLimit(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FrenchMorningComponent)
